import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Every custom utility we add in theme.css has to be registered here.
 *
 * tailwind-merge resolves conflicts from a built-in map of class groups. A class it
 * does not recognise is treated as unrelated to everything else, so it is never
 * dropped -- and never wins either. The failure is silent and specific: a caller
 * passing `rounded-card` to a wrapper whose default is `rounded-md` ends up with
 * BOTH classes, and whichever CSS rule happens to come last in the stylesheet wins.
 *
 * Keep this list in sync with the custom tokens in src/styles/theme.css.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // Custom radius scale. xs/sm/md/lg happen to share Tailwind's own names and are
      // already in the built-in group; card, sheet and pill are ours and must be listed
      // or they will not conflict with anything -- including each other.
      rounded: [{ rounded: ['card', 'sheet', 'pill'] }],
      'backdrop-blur': [{ 'backdrop-blur': ['glass'] }],
      shadow: [{ shadow: ['e1', 'e2', 'raised', 'glass', 'modal'] }],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
